export type GeoLocaleResult = {
  language: string
  currency: 'USD' | 'BRL' | 'EUR'
  countryCode: string
}

const LATIN_AMERICA_SPANISH = ['MX','CO','AR','CL','PE','VE','EC','BO','PY','UY','CR','SV','GT','HN','NI','PA','CU','DO','PR']
const EU_MINOR = ['AT','BE','IE','FI','GR','LU','SK','SI','EE','LV','LT','CY','MT']

export function getLocaleForCountry(countryCode: string): GeoLocaleResult {
  const cc = countryCode.toUpperCase()
  if (cc === 'BR') return { language: 'pt-BR', currency: 'BRL', countryCode: cc }
  if (cc === 'PT') return { language: 'pt-BR', currency: 'EUR', countryCode: cc }
  if (cc === 'ES') return { language: 'es-ES', currency: 'EUR', countryCode: cc }
  if (LATIN_AMERICA_SPANISH.includes(cc)) return { language: 'es', currency: 'USD', countryCode: cc }
  if (cc === 'FR') return { language: 'fr-FR', currency: 'EUR', countryCode: cc }
  if (cc === 'DE') return { language: 'de-DE', currency: 'EUR', countryCode: cc }
  if (cc === 'IT') return { language: 'it-IT', currency: 'EUR', countryCode: cc }
  if (cc === 'NL') return { language: 'nl-NL', currency: 'EUR', countryCode: cc }
  if (cc === 'PL') return { language: 'pl-PL', currency: 'EUR', countryCode: cc }
  if (EU_MINOR.includes(cc)) return { language: 'en', currency: 'EUR', countryCode: cc }
  return { language: 'en', currency: 'USD', countryCode: cc }
}

const CACHE_KEY = 'pd_geo_locale'

export function getCachedGeoLocale(): GeoLocaleResult | null {
  try {
    const cached = sessionStorage.getItem(CACHE_KEY)
    return cached ? (JSON.parse(cached) as GeoLocaleResult) : null
  } catch {
    return null
  }
}

export async function fetchGeoLocale(): Promise<GeoLocaleResult | null> {
  try {
    const cached = sessionStorage.getItem(CACHE_KEY)
    if (cached) return JSON.parse(cached) as GeoLocaleResult
  } catch { /* ignore */ }

  try {
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), 4000)
    const resp = await fetch('https://free.freeipapi.com/api/json', { signal: controller.signal })
    clearTimeout(timeoutId)
    if (!resp.ok) return null
    const data = await resp.json()
    const result = getLocaleForCountry(data.countryCode ?? 'US')
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(result))
    return result
  } catch {
    return null
  }
}
